var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.quotaTimes,"value":_vm.selectedQuotaTime,"label":_vm.$t('transportationPermission.quotaTime', 'Quota timeframe')},on:{"input":_vm.selectQuotaTime}})}
var staticRenderFns = []

export { render, staticRenderFns }